<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="add-custom-landing-page-url" :title="$t('frontend_groovesell_add_custom_landing_page_url')" width="600px" max-width="600px" >
    <form id="add-custom-landing-page-url-form" class="gs-aff-form" @submit.prevent="addLandingPageUrl()">
      <p>Give this page a recognizable name and enter its full destination URL.</p>
      <label>{{ $t('frontend_bonuses_name') }}
        <text-input v-model="localModel.name" :validator="validator.model.name" :attribute="$t('frontend_name')" :placeholder="$t('frontend_name')" />
      </label>
      <label>{{ $t('frontend_bouses_link') }}
        <text-input v-model="localModel.link" :validator="validator.model.link" attribute="Link" placeholder="https://" />
      </label>
    </form>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'add-custom-landing-page-url')">{{ $t('frontend_cancel') }}</gs-button>
      <gs-button variant="primary" type="submit" form="add-custom-landing-page-url-form">{{ $t('frontend_bouses_create') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import "../../affiliate-workspace.css";
export default {
    props: {
        validator: {
            required: true
        },
        model: {
            required: true
        },
        addLandingPageUrl: {
            required: true,
            type: Function
        }
    },
    data() {
        return {
            localModel: this.model
        }
    },
    watch: {
        localModel: {
            handler() {
                this.$emit('update-model', this.localModel)
            },
            deep: true
        }
    },
}
</script>
